/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputTargetWithZoneSelectData
 */
export interface OutputTargetWithZoneSelectData {
    /**
     * 
     * @type {string}
     * @memberof OutputTargetWithZoneSelectData
     */
    customTargetType: string;
    /**
     * 
     * @type {string}
     * @memberof OutputTargetWithZoneSelectData
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof OutputTargetWithZoneSelectData
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof OutputTargetWithZoneSelectData
     */
    targetType: number;
    /**
     * 
     * @type {string}
     * @memberof OutputTargetWithZoneSelectData
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof OutputTargetWithZoneSelectData
     */
    zone: number;
}

/**
 * Check if a given object implements the OutputTargetWithZoneSelectData interface.
 */
export function instanceOfOutputTargetWithZoneSelectData(value: object): boolean {
    if (!('customTargetType' in value)) return false;
    if (!('description' in value)) return false;
    if (!('id' in value)) return false;
    if (!('targetType' in value)) return false;
    if (!('title' in value)) return false;
    if (!('zone' in value)) return false;
    return true;
}

export function OutputTargetWithZoneSelectDataFromJSON(json: any): OutputTargetWithZoneSelectData {
    return OutputTargetWithZoneSelectDataFromJSONTyped(json, false);
}

export function OutputTargetWithZoneSelectDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputTargetWithZoneSelectData {
    if (json == null) {
        return json;
    }
    return {
        
        'customTargetType': json['custom_target_type'],
        'description': json['description'],
        'id': json['id'],
        'targetType': json['target_type'],
        'title': json['title'],
        'zone': json['zone'],
    };
}

export function OutputTargetWithZoneSelectDataToJSON(value?: OutputTargetWithZoneSelectData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'custom_target_type': value['customTargetType'],
        'description': value['description'],
        'id': value['id'],
        'target_type': value['targetType'],
        'title': value['title'],
        'zone': value['zone'],
    };
}

